import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { APIRoutes, ApiService } from 'src/app/services/api.service';


@Component({
    selector: 'app-cosmore',
    templateUrl: './cosmore.component.html',
    styleUrls: ['./cosmore.component.scss'],
    standalone: false
})
export class CosmoreComponent implements OnInit {

  name: string
  html: string

  @ViewChild('html') container!: ElementRef;


  constructor(
    public api: ApiService,
    private at: ActivatedRoute,
    private titleService: Title,
    private renderer: Renderer2
  ) {
    this.name = this.at.snapshot.paramMap.get('name')
  }

  ngOnInit() {
    this.load()
    
  }

  load() {
    window.location.href = this.api.baseurl + '/website/' +  this.name;
    // this.api.presentLoading()
    // this.api.get(APIRoutes.get_personal_website_content + this.name, (res) => {
    //   this.html = res.html ?? ''
    //   if(!this.html) {
    //     this.api.dismissLoading()
    //     window.location.href = 'https://cosmore.com/'
    //   }
    //   this.container.nativeElement.innerHTML = this.html
    //   this.titleService.setTitle(res.title);
    //   if(res.favicon) this.changeFavicon(res.favicon)
    //   this.api.dismissLoading()
    // })
  }

  changeFavicon(newIcon: string) {
    const link: HTMLLinkElement = this.renderer.selectRootElement('link[rel="icon"]', true);
    this.renderer.setAttribute(link, 'href', newIcon);
  }
}
